module.exports = __webpack_public_path__ + "img/tigertank.d3a98f88.png";